module.exports = __webpack_public_path__ + "img/132.159611f3.png";